import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import {
    Box,
    MuiAlertTitle,
    Button,
    RefreshOutlinedIcon,
} from '@bluedolphin/ui';
import { useTranslation } from 'react-i18next';

import { useApplication } from '../../../providers/application';
import { StyledMuiAlert, StyledBox } from './styles';
import { BPMN_PATH } from '../../../util/constants';

export const routePaths = [
    {
        path: `/:tenantId/${BPMN_PATH}`,
        exact: true,
        strict: false,
        navbar: true,
        shouldRefresh: false,
    },
    {
        path: `/:tenantId/${BPMN_PATH}/:diagramId`,
        exact: true,
        strict: false,
        navbar: false,
        shouldRefresh: false,
    },
    {
        path: '/:tenantId/drafts',
        exact: false,
        strict: false,
        navbar: true,
        shouldRefresh: true,
    },
];

/**
 * DisruptiveErrorModal
 */
export default function DisruptiveErrorModal() {
    const { t } = useTranslation();
    const { isErrorModalVisible, errorModalMessage } = useApplication();
    const { pathname } = useLocation();

    const routeMatch = useMemo(() => {
        let matchFound = null;

        routePaths.forEach((route) => {
            if (matchPath(pathname, route)) {
                matchFound = route;
            }
        });

        return matchFound;
    }, [isErrorModalVisible, pathname]);

    /**
     * handle error toast actions
     */
    function onErrorActionClick() {
        if (errorModalMessage.action === 'refresh') {
            window.location.reload();
        }
    }

    return isErrorModalVisible && routeMatch?.path ? (
        <StyledBox
            sx={{
                height: '100vh',
                width: '100vw',
                position: 'fixed',
                zIndex: 9999999999,
                top: 0,
                left: 0,
                background: 'rgba(255, 255, 255, 0.5)',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <StyledMuiAlert
                hasNavBar={routeMatch.navbar}
                action={
                    errorModalMessage.action && (
                        <Button
                            onClick={onErrorActionClick}
                            endIcon={<RefreshOutlinedIcon />}
                            color="inherit"
                            sx={{ textTransform: 'capitalize' }}
                        >
                            {t(`modalErrorActions.${errorModalMessage.action}`)}
                        </Button>
                    )
                }
                severity="error"
            >
                {errorModalMessage.title && (
                    <MuiAlertTitle>{errorModalMessage.title}</MuiAlertTitle>
                )}
                <Box sx={{ maxWidth: 350 }}>
                    {errorModalMessage.description}
                </Box>
            </StyledMuiAlert>
        </StyledBox>
    ) : null;
}
